































































import { Component, Prop, Vue } from 'vue-property-decorator';
import GalaHonorAction from '~/components/GalaHonor/GalaHonorAction.vue';
import { HonorAction, IHonorAction } from '~/store/profile/types';
import honorActionsByUser from '~/queries/honorActionsByUser.gql';
import InfiniteLoading from 'vue-infinite-loading';

@Component({
  components: { GalaHonorAction, InfiniteLoading },
})
export default class GalaHonorActionHistory extends Vue {
  @Prop(String) readonly game!: string;

  isFetching = true;
  actions: IHonorAction[] = [];
  limit = 20;
  offset = 0;
  infiniteId = +new Date();
  actionFilters = [
    {
      value: HonorAction.PLAY_AND_EARN,
      text: this.$t('pages.galaHonor.playAndEarn'),
    },
    {
      value: HonorAction.PURCHASE,
      text: this.$t('pages.galaHonor.purchase'),
    },
    {
      value: HonorAction.BRIDGE_CURRENCY_TO_GYRI,
      text: this.$t('pages.galaHonor.bridgeCurrencyToGyri', {
        currency: 'SILK',
      }),
    },
    {
      value: HonorAction.BRIDGE_CURRENCY_TO_ETH,
      text: this.$t('pages.galaHonor.bridgeCurrencyToEth', {
        currency: 'SILK',
      }),
    },
    {
      value: HonorAction.RUN_NODE,
      text: this.$t('pages.galaHonor.runNode'),
    },
    {
      value: HonorAction.TRANSFER_CURRENCY,
      text: this.$t('pages.galaHonor.transferCurrency', { currency: 'SILK' }),
    },
  ];
  filter = this.actionFilters.map(x => x.value);
  showErrorSnackbar = false;
  errorSnackbarText = '';

  triggerErrorSnackbar(message?: string) {
    this.errorSnackbarText = message || 'Something Went Wrong';
    this.showErrorSnackbar = true;
  }

  async infiniteScroll($state: any) {
    try {
      const { data } = await this.$apollo.query<{
        honorActionsByUser: {
          success: boolean;
          data: { actions: IHonorAction[]; total: number };
        };
      }>({
        query: honorActionsByUser,
        fetchPolicy: 'no-cache',
        variables: {
          game: this.game,
          limit: this.limit,
          offset: this.offset,
          filter: this.filter.join(','),
        },
      });
      const response = data.honorActionsByUser;

      if (!response.success) {
        this.triggerErrorSnackbar('Could not retrieve honor actions');
      }

      if (!!response.data.actions.length) {
        this.actions.push(...response.data.actions);
        this.offset += this.limit;
      }

      if (
        this.actions.length === response.data.total ||
        this.actions.length === 0
      ) {
        $state.complete();
      }

      $state.loaded();
    } catch (e) {
      this.triggerErrorSnackbar('Could not retrieve honor actions');
      $state.complete();
    }
  }

  changeFilter() {
    this.actions = [];
    this.offset = 0;
    this.infiniteId++;
  }
}
